export const ExternalDatasetsSchema = {
  type: "object",
  required: [
    "assetType",
    "dataLevel",
    "habitatReferences",
    "licenses",
    "publicationDate",
    "responsibleOrganizations",
  ],
  properties: {
    alternateIdentifiers: {
      $id: "elter://metadata.schemas/subschemas/alternateIdentifiers.json",
      "x-label": "Alternate identifier(s)",
      "x-tooltip":
        "The alternative identifiers for this resource such as a URN, URI or an ISBN number.",
      type: "array",
      items: {
        type: "object",
        properties: {
          alternateID: {
            type: "string",
            "x-label": "Alternate identifier",
            "x-tooltip":
              "Please provide the reference/identifier to the related resource.",
          },
          alternateIDType: {
            type: "string",
            "x-label": "Related Identifier Type",
            "x-tooltip": "The type of identifier.",
            enumValues: [
              "ARK",
              "arXiv",
              "bibcode",
              "DOI",
              "EAN13",
              "EISSN",
              "Handle",
              "ISBN",
              "ISSN",
              "ISTC",
              "LISSN",
              "LSID",
              "ORCID",
              "PMID",
              "PURL",
              "UPC",
              "URL",
              "URN",
              "w3id",
              "URI",
            ],
          },
        },
      },
    },
    assetType: {
      $id: "elter://metadata.schemas/subschemas/assetType.json",
      type: "string",
      "x-required": true,
      enum: [
        "Audiovisual",
        "Book",
        "BookChapter",
        "Collection",
        "ComputationalNotebook",
        "ConferencePaper",
        "ConferenceProceeding",
        "DataPaper",
        "Dataset",
        "Dissertation",
        "Event",
        "Image",
        "InteractiveResource",
        "Journal",
        "JournalArticle",
        "Model",
        "OutputManagementPlan",
        "PeerReview",
        "PhysicalObject",
        "Preprint",
        "Report",
        "Service",
        "Software",
        "Sound",
        "Standard",
        "Text",
        "Workflow",
        "Other",
      ],
    },
    datasetType: {
      $id: "elter://metadata.schemas/subschemas/datasetType.json",
      type: "object",
      "x-label": "asset type",
      "x-tooltip":
        "Please provide the corresponding eLTER standard observation for the dataset.",
      properties: {
        datasetTypeCode: {
          type: "string",
          enum: [
            "SOGEO_001",
            "SOGEO_003",
            "SOGEO_167",
            "SOGEO_048",
            "SOGEO_155",
            "SOHYD_004",
            "SOHYD_005",
            "SOHYD_006",
            "SOHYD_169",
            "SOHYD_170",
            "SOHYD_171",
            "SOHYD_010",
            "SOHYD_011",
            "SOHYD_012",
            "SOHYD_168",
            "SOHYD_058",
            "SOHYD_059",
            "SOHYD_062",
            "SOHYD_064",
            "SOHYD_067",
            "SOHYD_164",
            "SOHYD_165",
            "SOHYD_166",
            "SOHYD_174",
            "SOBIO_014",
            "SOBIO_017",
            "SOBIO_018",
            "SOBIO_019",
            "SOBIO_021",
            "SOBIO_022",
            "SOBIO_096",
            "SOHYD_172",
            "SOHYD_173",
            "SOATM_027",
            "SOATM_028",
            "SOATM_098",
            "SOATM_103",
            "SOATM_108",
            "SOATM_176",
            "SOBIO_023",
            "SOBIO_177",
            "SOBIO_024",
            "SOBIO_090",
            "SOBIO_091",
            "SOBIO_092",
            "SOBIO_093",
            "SOBIO_015",
            "SOBIO_016",
            "SOBIO_025",
            "SOBIO_026",
            "SOBIO_095",
            "SOBIO_140",
            "SOSOC_031",
            "SOSOC_030",
            "SOSOC_114",
            "SOSOC_032",
            "SOSOC_036",
            "SOSOC_037",
            "SOSOC_040",
            "SOSOC_042",
            "SOSOC_043",
            "SOSOC_044",
            "SOSOC_045",
            "SOSOC_183",
            "SOSOC_184",
            "NotSpecified",
          ],
        },
        datasetTypeURI: {
          type: "string",
        },
      },
    },
    contactPoints: {
      $id: "elter://metadata.schemas/subschemas/contactPoints.json",
      type: "array",
      items: {
        type: "object",
        properties: {
          contactEmail: {
            type: "string",
          },
          contactName: {
            type: "string",
          },
        },
      },
    },
    contributors: {
      $id: "elter://metadata.schemas/subschemas/contributors.json",
      type: "object",
      properties: {
        creators: {
          type: "array",
          "x-label": "Creators",
          "x-tooltip":
            "The full name of the creators and/or owners of the dataset. The personal name format should be: family, given (e.g.: Smith, John).",
          items: {
            type: "object",
            properties: {
              creatorGivenName: {
                type: "string",
                "x-label": "Given name",
                "x-tooltip": "The first names given to this entity.",
              },
              creatorFamilyName: {
                type: "string",
                "x-label": "Family name",
                "x-tooltip": "The family names given to this entity.",
                required: true,
              },
              creatorEmail: {
                type: "string",
                "x-label": "eMail",
                "x-tooltip": "Contact email address of the author.",
                required: true,
              },
              creatorAffiliation: {
                type: "string",
                "x-label": "Organization/Group name",
                "x-tooltip":
                  "Name of the (current) organisation of the author.",
                required: true,
              },
              entityID: {
                type: "object",
                properties: {
                  entityID: {
                    type: "string",
                  },
                  entityIDSchema: {
                    type: "string",
                  },
                },
              },
            },
            creatorIDs: {
              type: "array",
              required: false,
              items: {
                type: "object",
                properties: {
                  entityID: {
                    TODO: "id looks better, shorter -> it is under the nameIdentifiers...",
                    type: "string [uri]",
                    "x-label": "Identifier",
                    "x-tooltip":
                      "The unique identifier of the entity, according to various identifier schemes.",
                  },
                  entityIDSchema: {
                    type: "enum",
                    "x-label": "Scheme",
                    "x-tooltip": "The scheme used for the identifier.",
                    default: "orcid",
                    enum: ["orcid", "wob", "scopus"],
                  },
                },
              },
            },
          },
        },
      },
    },
    creators: {
      $id: "elter://metadata.schemas/subschemas/creators.json",
      type: "object",
      properties: {
        a: "b",
      },
    },
    dataLevel: {
      $id: "elter://metadata.schemas/subschemas/dataLevel.json",
      "x-label": "Data Level",
      "x-required": true,
      type: "object",
      $comment: "TODO: this will be done with vocabs in the future",
      "x-tooltip": "Data level according to the eLTER defined data levels.",
      "x-tooltip2":
        "TBD - see https://elter.atlassian.net/wiki/spaces/EC/pages/918749186/eLTER+Data+Levels",
      properties: {
        dataLevelCode: {
          type: "string",
          enumValues: ["0", "1", "2", "3"],
        },
        dataLevelURI: {
          type: "string",
          "x-tooltip": "Provide url to the concept in the eLTER vocabularies.",
          $comment:
            "TODO: this will be taken automatically from the vocabulary in future",
        },
      },
    },
    descriptions: {
      $id: "elter://metadata.schemas/subschemas/descriptions.json",
      "x-label": "Descriptions",
      type: "array",
      items: {
        type: "object",
        required: ["descriptionText", "descriptionType"],
        properties: {
          descriptionText: {
            type: "string",
            "x-label": "Description",
            "min-length": 200,
            "max-length": 4000,
            "comment-on-length": "number of characters",
            TODO: "Choose x-tooltip",
            "x-tooltip":
              "The more elaborate description of the resource. Focus on a content description that makes it easy for others to find, and to interpret its relevance.",
            "x-tooltip2":
              "Please describe the dataset with an abstract of at least 200 characters. Please consider giving the description more structure by adding additional description fields.",
            "x-required": true,
          },
          descriptionType: {
            type: "string",
            "x-label": "Type",
            "x-tooltip": "The type of description.",
            "x-required": true,
            enumValues: [
              "Abstract",
              "AdditionalInfo",
              "Methods",
              "SeriesInformation",
              "TableOfContents",
              "TechnicalInfo",
              "Other",
            ],
          },
        },
      },
    },
    geoLocations: {
      $id: "elter://metadata.schemas/subschemas/geoLocations.json",
      type: "array",
      items: {
        type: "object",
        properties: {
          boundingBox: {
            type: "object",
            properties: {
              eastBoundLongitude: {
                type: "number",
              },
              northBoundLatitude: {
                type: "number",
              },
              southBoundLatitude: {
                type: "number",
              },
              westBoundLongitude: {
                type: "number",
              },
            },
          },
          boundingPolygon: {
            type: "array",
            items: {
              type: "object",
              properties: {
                inPolygonPoint: {
                  type: "object",
                  properties: {
                    latitude: {
                      type: "number",
                    },
                    longitude: {
                      type: "number",
                    },
                  },
                },
                points: {
                  type: "array",
                  items: {
                    type: "object",
                    properties: {
                      latitude: {
                        type: "number",
                      },
                      longitude: {
                        type: "number",
                      },
                    },
                  },
                },
              },
            },
          },
          geographicDescription: {
            type: "string",
          },
          observationLocation: {
            type: "object",
            properties: {
              deimsLocationID: {
                type: "string",
              },
              deimsLocationName: {
                type: "string",
              },
            },
          },
          point: {
            type: "object",
            properties: {
              latitude: {
                type: "number",
              },
              longitude: {
                type: "number",
              },
            },
          },
        },
      },
    },
    habitatReferences: {
      $id: "elter://metadata.schemas/subschemas/habitatReferences.json",
      type: "array",
      "x-label": "Related habitats",
      "x-tooltip":
        "Provide informaiton on the habitats for which the datasource was created.",
      "x-required": true,
      items: {
        type: "object",
        properties: {
          soHabitatCode: {
            type: "string",
          },
          soHabitatURI: {
            type: "string",
          },
        },
      },
    },
    keywords: {
      $id: "elter://metadata.schemas/subschemas/keywords.json",
      type: "array",
      "x-label": "Keywords",
      "x-tooltip": "The keywords or key phrases describing the resource.",
      items: {
        type: "object",
        properties: {
          keywordLabel: {
            type: "string",
          },
          keywordURI: {
            type: "string",
          },
        },
      },
    },
    language: {
      $id: "elter://metadata.schemas/subschemas/language.json",
      type: "string",
    },
    licenses: {
      $id: "elter://metadata.schemas/subschemas/licenses.json",
      type: "array",
      "x-label": "License",
      "x-tooltip":
        "The license under which this data set is available to the users (e.g. GPL, Apache v2 or Commercial). Please use the License Selector for help and additional information.",
      "x-required": true,
      $comment: "Required once but more than one occurence is allowed.",
      items: {
        type: "object",
        properties: {
          licenseCode: {
            type: "string",
            "x-tooltip": "For example CC BY-SA 4.0",
          },
          licenseURI: {
            type: "string",
            "x-tooltip":
              "For example https://creativecommons.org/licenses/by-sa/4.0/deed.en",
          },
        },
      },
    },
    methods: {
      $id: "elter://metadata.schemas/subschemas/methods.json",
      id: "subschemas/methods.json",
      type: "array",
      items: {
        type: "object",
        properties: {
          instrumentationDescription: {
            type: "string",
          },
          methodID: {
            type: "string",
          },
          qualityControlDescription: {
            type: "string",
          },
          sampling: {
            type: "object",
            properties: {
              samplingDescription: {
                type: "string",
              },
              studyDescription: {
                type: "string",
              },
            },
          },
          steps: {
            type: "array",
            items: {
              type: "object",
              properties: {
                stepDescription: {
                  type: "string",
                },
                stepTitle: {
                  type: "string",
                },
              },
            },
          },
        },
      },
    },
    projects: {
      $id: "elter://metadata.schemas/subschemas/projects.json",
      type: "array",
      items: {
        type: "object",
        "x-label": "Project",
        "x-tooltip":
          "Information on the project or funding source for the resource.",
        properties: {
          projectName: {
            type: "string",
          },
          projectID: {
            type: "string",
            "x-label": "Project identifier",
            "x-tooltip":
              "Persistent identifier (e.g. CORDIS-ID, DOI) for the project.",
            required: false,
          },
        },
      },
    },
    publicationDate: {
      $id: "elter://metadata.schemas/subschemas/publicationDate.json",
      type: "string",
      "x-label": "Publication date",
      "x-tooltip":
        "The date when the data was or will be made publicly available (e.g. 2018-07-13).",
      "x-required": true,
      format: "YYYY-MM-DD",
    },
    relatedIdentifiers: {
      $id: "elter://metadata.schemas/subschemas/relatedIdentifiers.json",
      type: "array",
      "x-label": "Related identifiers",
      "x-tooltip":
        "The identifiers of other resources related to the resource such as a URN, URI or an ISBN number.",
      items: {
        type: "object",
        properties: {
          relatedID: {
            type: "string",
            "x-label": "Related identifier",
            "x-tooltip":
              "Please provide the reference/identifier to the related resource.",
          },
          relatedResourceType: {
            type: "enum",
            enumValues: [
              "Audiovisual",
              "Book",
              "BookChapter",
              "Collection",
              "ComputationalNotebook",
              "ConferencePaper",
              "ConferenceProceeding",
              "DataPaper",
              "Dataset",
              "Dissertation",
              "Event",
              "Image",
              "InteractiveResource",
              "Journal",
              "JournalArticle",
              "Model",
              "OutputManagementPlan",
              "PeerReview",
              "PhysicalObject",
              "Preprint",
              "Report",
              "Service",
              "Software",
              "Sound",
              "Standard",
              "Text",
              "Workflow",
              "Other",
            ],
          },
          relatedIDType: {
            type: "enum",
            "x-label": "Related Identifier Type",
            "x-tooltip": "The type of identifier.",
            enumValues: [
              "ARK",
              "arXiv",
              "bibcode",
              "DOI",
              "EAN13",
              "EISSN",
              "Handle",
              "ISBN",
              "ISSN",
              "ISTC",
              "LISSN",
              "LSID",
              "ORCID",
              "PMID",
              "PURL",
              "UPC",
              "URL",
              "URN",
              "w3id",
              "URI",
            ],
          },
          relationType: {
            type: "enum",
            "x-label": "Relation",
            "x-tooltip": "The relation type of the described reference.",
            enumValues: [
              "IsCitedBy",
              "Cites",
              "IsSupplementTo",
              "IsPublishedIn",
              "IsSupplementedBy",
              "IsContinuedBy",
              "Continues",
              "HasMetadata",
              "IsMetadataFor",
              "IsNewVersionOf",
              "IsPreviousVersionOf",
              "IsPartOf",
              "HasPart",
              "IsReferencedBy",
              "References",
              "IsDocumentedBy",
              "Documents",
              "isCompiledBy",
              "Compiles",
              "IsVariantFormOf",
              "IsOriginalFormOf",
              "IsIdenticalTo",
              "IsReviewedBy",
              "Reviews",
              "IsDerivedFrom",
              "IsSourceOf",
              "Describes",
              "IsDescribedBy",
              "HasVersion",
              "IsVersionOf",
              "Requires",
              "IsRequiredBy",
              "Obsoletes",
              "IsObsoletedBy",
            ],
          },
        },
      },
    },
    responsibleOrganizations: {
      $id: "elter://metadata.schemas/subschemas/responsibleOrganizations.json",
      type: "array",
      "x-label": "Responsible Organisations",
      definition:
        "Responsible organisation and contact information owning the resource.",
      "x-tooltip":
        "Responsible organisation and contact information owning the resource.",
      "x-required": true,
      items: {
        type: "object",
        properties: {
          organisation_name: {
            type: "string",
            "x-label": "Organisation name",
            "x-tooltip": "Provide the name of the responsible organisation",
          },
          email: {
            type: "string",
            "x-label": "Contact information",
            "x-tooltip": "Contact email for the resource.",
          },
          organisation_identifier: {
            type: "string",
            "x-label": "Organisation ID",
            placeholder: "https://ror.org/000h6jb29",
            "x-tooltip":
              "Provide identifier (e.g. ROR) for the organisation, e.g. https://ror.org/",
          },
        },
      },
    },
    taxonomicCoverages: {
      $id: "elter://metadata.schemas/subschemas/taxonomicCoverages.json",

      type: "array",
      items: {
        type: "object",
        properties: {
          taxonomicClassification: {
            type: "object",
            properties: {
              taxonomicClassificationID: {
                type: "string",
              },
              taxonomicCommonName: {
                type: "string",
              },
              taxonomicRankName: {
                type: "string",
              },
              taxonomicRankValue: {
                type: "string",
              },
            },
          },
          taxonomicDescription: {
            type: "string",
          },
        },
      },
    },
    temporalCoverages: {
      $id: "elter://metadata.schemas/subschemas/temporalCoverages.json",
      "x-required": "once",
      type: "array",
      "x-label": "Temporal coverage(s)",
      "x-tooltip": "The temporal coverage of the contents of the resource.",
      items: {
        type: "object",
        properties: {
          startDate: {
            type: "string",
            "x-label": "Start date",
            "x-tooltip":
              "The start date and time of the range covered by the resource.",
            format: "date",
          },
          endDate: {
            type: "string",
            "x-label": "End date",
            "x-tooltip":
              "The end date and time of the range covered by the resource.",
            format: "date",
          },
        },
      },
    },
    temporalResolution: {
      $id: "elter://metadata.schemas/subschemas/temporalResolution.json",
      "x-required": false,
      "x-label": "Temporal Resolution",
      type: "array",
      items: {
        type: "object",
        required: ["temporalResolutionValue", "temporalResolutionUnit"],
        properties: {
          temporalResolutionValue: {
            "x-required": true,
            "x-label": "Resolution value",
            type: "integer",
          },
          temporalResolutionUnit: {
            "x-required": true,
            "x-label": "Unit",
            type: "string",
            enum: [
              "Hz",
              "Minutes",
              "Hours",
              "Days",
              "Weeks",
              "Months",
              "Years",
            ],
          },
        },
      },
    },
    titles: {
      $id: "elter://metadata.schemas/subschemas/titles.json",
      type: "array",
      items: {
        type: "object",
        required: "titleText",
        properties: {
          titleLanguage: {
            type: "string",
          },
          titleText: {
            "x-label": "Title",
            "x-tooltip": "Title for the resource.",
            "x-required": true,
            type: "string",
          },
        },
      },
    },
    version: {
      $id: "elter://metadata.schemas/subschemas/version.json",
      type: "string",
    },
  },
};
